import { render, staticRenderFns } from "./auth-failed.vue?vue&type=template&id=9120d7f0&"
import script from "./auth-failed.vue?vue&type=script&lang=js&"
export * from "./auth-failed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports